import { Text } from '@bechtel/gds';
import styled from 'styled-components';

export const CommodityItemStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  flex-grow: 1;
  margin-bottom: ${({ theme }) => theme.spacings[400]};
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const CommodityItemInfoStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacings[400]};
  padding-bottom: ${({ theme }) => theme.spacings[400]};
  padding-left: ${({ theme }) => theme.spacings[500]};
  padding-right: ${({ theme }) => theme.spacings[500]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[500]};
`;

export const MilestoneListStyled = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[500]};
`;

export const CommodityTagTextStyled = styled(Text)`
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: normal;
`;
